import { useEffect } from 'react';
import { useNavigate, generatePath } from 'react-router-dom';

import { useGetUserContextQuery } from '@/entities/layout';
import { createIdentifiableSlug } from '@/shared/lib/utils/slug-utils';
import { RouteNames } from '@/shared/config/routes';

export const ProjectSiteRedirect = () => {
  const navigate = useNavigate();
  const { data: userContext, isLoading } = useGetUserContextQuery();

  useEffect(() => {
    if (userContext) {
      if (userContext.user?.preferredProjectId && userContext.user?.preferredSiteId) {
        const projectId = createIdentifiableSlug(
          userContext.user.preferredProjectName || '',
          userContext.user.preferredProjectId
        );
        const siteId = createIdentifiableSlug(
          userContext.user.preferredSiteName || '',
          userContext.user.preferredSiteId
        );

        navigate(generatePath(RouteNames.DASHBOARD_STORAGE, { projectId, siteId }), {
          replace: true
        });
        return;
      }

      if (userContext.projects?.[0]?.sites?.[0]) {
        const project = userContext.projects[0];
        const site = project.sites[0];

        const projectId = createIdentifiableSlug(project.name, project.id);
        const siteId = createIdentifiableSlug(site.name, site.id);

        navigate(generatePath(RouteNames.DASHBOARD_STORAGE, { projectId, siteId }), {
          replace: true
        });
        return;
      }
    }
  }, [userContext, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p>Loading project context...</p>
        </div>
      </div>
    );
  }

  if (userContext && !userContext.projects?.length) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center text-destructive">
          <p>No projects available</p>
          <p className="text-sm text-muted-foreground mt-1">Please contact your administrator</p>
        </div>
      </div>
    );
  }

  return null;
};
